// Live SLA countdown. Decrements every second; turns red when breached.
import { useEffect, useState } from "react";
import { cn } from "../lib/utils";
import { AlarmClock, AlertTriangle, PauseCircle } from "lucide-react";

function fmt(secs) {
  const neg = secs < 0;
  let s = Math.abs(Math.floor(secs));
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  s -= m * 60;
  const txt = `${h}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
  return neg ? `+${txt}` : txt;
}

export function SlaCountdown({ label, secondsLeft, paused, testId }) {
  const [secs, setSecs] = useState(secondsLeft);

  useEffect(() => setSecs(secondsLeft), [secondsLeft]);

  useEffect(() => {
    if (paused || secs == null) return;
    const t = setInterval(() => setSecs((v) => v - 1), 1000);
    return () => clearInterval(t);
  }, [paused, secs == null]);

  if (secs == null) return null;
  const breached = secs < 0;
  const warning = secs >= 0 && secs < 3600 * 6;

  return (
    <div
      data-testid={testId}
      className={cn(
        "border p-3 transition-all duration-200",
        breached
          ? "bg-signal text-white border-signal"
          : warning
          ? "bg-warn/20 border-warn"
          : "bg-white border-border"
      )}
    >
      <div className="flex items-center gap-1.5 label-caps opacity-80">
        {paused ? <PauseCircle size={12} /> : breached ? <AlertTriangle size={12} /> : <AlarmClock size={12} />}
        {label} {paused && "(paused)"}
      </div>
      <div className="font-mono text-lg font-semibold mt-1 tabular-nums">
        {breached ? "OVERDUE " : ""}
        {fmt(secs)}
      </div>
    </div>
  );
}
